import React, {useState, useContext, useEffect} from 'react';
import SideNav from '../shared/SideNav';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import EditTimeModel from './EditTimeModel';
import Breadcrumb from '../../shared/Breadcrumb';
import { apiRoutes } from '../../../AppSettings';
import alertify from "alertifyjs";
import Util from '../../../Util';

const ScheduleTiming = () => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const [modalShow, setModalShow] = useState(false);
    const [modalBody, setModalBody] = useState([]);
    const [modalDay, setModalDay] = useState([]);

    const { userState } = useContext(AuthContext);
    const [doctor, setDoctor] = useState(userState.loggedInUser);
    const [scheduleTimes, setScheduleTimes] = useState({});
    
    const loggedInDoctorId = userState.user.userId;
    
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    const updateScheduleTIme = data => {
        setScheduleTimes(data);
    } 

    const deleteSchedule = (day, scheduleTimingId) => {
        days.forEach(element => {
            if(element === day)
            {
                scheduleTimes[element] = scheduleTimes[element].filter(item => {
                        return item.scheduleTimingId != scheduleTimingId
                    });
            }
        });

        setScheduleTimes(scheduleTimes); 

        axios.post(apiRoutes.deleteSchedule, JSON.stringify({scheduleTimingId: scheduleTimingId}), options)
            .then((response) => {
                if(response.status === 200)
                {
                    alertify.success("Selected schedule deleted");
                }
            }, (error) => {
                console.log(error.response);
                alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
      
        });
    } 

    const ShowModel =(day) => {
        let selectedDay = JSON.parse(JSON.stringify(scheduleTimes[day])); 

        setModalBody(selectedDay);
        setModalDay(day);
        setModalShow(true);
    }

    useEffect(() => {
        axios.get(apiRoutes.getScheduleTimes + loggedInDoctorId, options)
          .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                console.log(data.scheduleTimes);
                updateScheduleTIme(data.scheduleTimes);
            }
          }, (error) => {
            console.log(error.response);
            alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
          });
    }, []);

    return (  
        <div>
            <Breadcrumb title="Schedule Timings" />
            <div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                           <SideNav applyCssFor = 'scheduletiming' user={doctor}/>
						</div>
						<div className="col-md-7 col-lg-8 col-xl-9">
							<div className="row">
								<div className="col-sm-12">
									<div className="card">
										<div className="card-body">
											<h4 className="card-title">Schedule Timings</h4>
											<div className="profile-box">
												<div className="row">
                    								<div className="col-lg-4">
														<div className="form-group">               
															<label>Timing Slot Duration</label>
															<select className="select form-control">
																<option>-</option>
																<option>15 mins</option>
																<option>30 mins</option>  
																<option>45 mins</option>
																<option>1 Hour</option>
															</select>
														</div>
													</div>
												</div>     
												<div className="row">
													<div className="col-md-12">
														<div className="card schedule-widget mb-0">
															<div className="schedule-header">
																<div className="schedule-nav">
																	<ul className="nav nav-tabs nav-justified">
                                                                        {
                                                                            days.map(d => (
                                                                                <li key={d} className="nav-item">
                                                                                    <a className={d === days[(new Date()).getDay()] ? 'nav-link active' : 'nav-link' } data-toggle="tab" href={"#slot_"+d}>{d}</a>
                                                                                </li>
                                                                            ))
                                                                        }
																	</ul>
																</div>
															</div>
															<div className="tab-content schedule-cont">
                                                            {
                                                                days.map(d => (
                                                                    <div key={d} id={"slot_"+d} className={d === days[(new Date()).getDay()] ? 'tab-pane fade show active' : 'tab-pane fade' }>
                                                                        <h4 className="card-title d-flex justify-content-between">
                                                                            <span>Time Slots</span> 
                                                                            {
                                                                                scheduleTimes[d] != undefined &&
                                                                                (
                                                                                scheduleTimes[d].length > 0 ?  
                                                                                    <Link className="edit-link" onClick={() => ShowModel(d)}> <i className="fa fa-edit mr-1"></i>Edit</Link>
                                                                                    : <Link className="edit-link" onClick={() => ShowModel(d)}><i className="fa fa-plus-circle"></i> Add Slot</Link>
                                                                                )
                                                                            }
                                                                        </h4>
                                                                        <div className="doc-times">
                                                                            {
                                                                                scheduleTimes[d] != undefined &&
                                                                                scheduleTimes[d].length == 0 ? 
                                                                                    <p className="text-muted mb-0">Not Available</p>
                                                                                    : 
                                                                                    scheduleTimes[d] != undefined &&
                                                                                    scheduleTimes[d].map(s => (
                                                                                        <div key={s.startTime} className="doc-slot-list">
                                                                                            {s.startTime} - {s.endTime}
                                                                                            <Link onClick={() => deleteSchedule(d, s.scheduleTimingId)} className="delete_schedule">
                                                                                                <i className="fa fa-times"></i>
                                                                                            </Link>
                                                                                        </div>
                                                                                    ))
                                                                                    
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>	

            <EditTimeModel
                show={modalShow}
                onHide={() => setModalShow(false)}
                body = {modalBody}
                day = {modalDay} 
            />
        </div>
    );
}
 
export default ScheduleTiming;